import React, { useEffect, useState, useRef } from "react";
import * as StyleFunctions from '../utilities/StyleFunctions';

function App(props) {

    var insideStyle = props.insideStyle;
    var outsideStyle = props.outsideStyle;
    var onClick = props.onClick;
    var draggable = props.draggable;
    var onDragStart = props.onDragStart;
    var onDrag = props.onDrag;
    var onDragEnd = props.onDragEnd;
    var addClassNames = props.addClassNames;
  var doAScreenRef = props.doAScreenRef;
  var itemPath = props.itemPath;

    const [tickTock, setTickTock] = useState(0);

  const ref1 = useRef();

  useEffect(()=>{
    doAScreenRef(ref1, itemPath);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps


  function toggleTime(t){
    setTickTock(t);
    setTimeout(function(){ toggleTime(1 - t); }, 1000);
  }

  useEffect(() => {
    toggleTime(0);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var nosTime = new Date();
  var nowTime = insideStyle.time;
  if (Number(nowTime)){
    nowTime = Number(nowTime);
  }else{
    nowTime = Math.floor(nowTime/1000);
    console.warn("Please re-set the timer by keying in the number again");
  }
  var timeDiff = Math.floor(nosTime.getTime()/1000) - nowTime;
  if (insideStyle.reverse){
    timeDiff = - timeDiff;
  }
  if (insideStyle.stopAt0){
    if (timeDiff < 0){
      timeDiff = 0;
    }
  }
  var splitTime = StyleFunctions.calcTimeSplit(timeDiff);

  var mainstyle = {};
  mainstyle.backgroundColor = insideStyle.backgroundColor;
  mainstyle.color = insideStyle.color;
  mainstyle.borderColor = insideStyle.borderColor;
  mainstyle.borderStyle = insideStyle.borderStyle;
  if (insideStyle.borderRadius){
    mainstyle.borderRadius = insideStyle.borderRadius;
  }else{
    mainstyle.borderTopLeftRadius = insideStyle.borderTopLeftRadius;
    mainstyle.borderTopRightRadius = insideStyle.borderTopRightRadius;
    mainstyle.borderBottomLeftRadius = insideStyle.borderBottomLeftRadius;
    mainstyle.borderBottomRightRadius = insideStyle.borderBottomRightRadius;
  }
  mainstyle.borderWidth = insideStyle.borderWidth;

  var numberStyle = {};
  var unitStyle = {};

  if (insideStyle.legendColor){
    unitStyle.color = insideStyle.legendColor;
  }
  if (insideStyle.legendBackgroundColor){
    unitStyle.backgroundColor = insideStyle.legendBackgroundColor;
  }
  if (insideStyle.counterBackgroundColor){
    numberStyle.backgroundColor = insideStyle.counterBackgroundColor;
  }
  if (insideStyle.counterRadius){
    numberStyle.borderRadius = insideStyle.counterRadius;
  }
  if (insideStyle.counterPadding){
    numberStyle.padding = insideStyle.counterPadding;
  }

  var set;

  var gotSomething = false;

  var setOut = [];
  var pieces = ['days','hours','minutes', 'seconds'];
  pieces.forEach((aP, index)=>{
    var days = splitTime[aP];
    if (!days && !gotSomething && aP !== 'seconds'){
    }else{
      gotSomething = true;
      if (days < 10 && aP !== 'days'){
        days = '0' + days;
      }else{
        days = ''+days;
      }

      if (insideStyle.hideSeconds && aP === 'seconds' && splitTime.days > 0){
      }else{
        setOut.push({t:aP, days})
      }
    }
  });

  if (insideStyle.timerType === 'narrowTimer'){
    var xStyle = {padding:'10px', fontSize:'15px'};
    var setTxt = setOut.map((aP, index)=>{
      return aP.days;
    }).join(':');
    set = <div className='countdown-timer2' style={{...xStyle, ...mainstyle}}>{setTxt}</div>
//
  }else{
    gotSomething = false;
    set = setOut.map((aP, index)=>{
      return <div className='countdown-item' key={index} style={mainstyle}>
                      <div style={numberStyle}>{aP.days}</div>
                      <span style={unitStyle}>{aP.t}</span>
                  </div>
    })      

  }
//

  return <div ref={ref1} style={outsideStyle} className={addClassNames} draggable={draggable} onClick={onClick} onDragStart={onDragStart} onDrag={onDrag} onDragEnd={onDragEnd}>
                <div className="countdown-wrapper">{set}</div></div>
}



export default App;